import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { DataEndpoint } from '@core/models/general.model';
import { Observable, map } from 'rxjs';
import { HttpUtils } from '@core/utils/http.utils';
import { ActivitiesFilterModel, ActivitiesModel, ActivitiesPostModel, ActivityFilesModel } from '../models/activities.model';

@Injectable({
  providedIn: 'root',
})
export class ActivitiesApi {
  private readonly http = inject(HttpClient);
  private readonly ACTIVITIES = '/Activities';

  getActivities(request: ActivitiesFilterModel): Observable<DataEndpoint<ActivitiesModel>> {
    const url = this.ACTIVITIES;
    const params = HttpUtils.objectToHttpParams(request);

    return this.http.get<DataEndpoint<ActivitiesModel>>(url, { params })
      .pipe(map((data: DataEndpoint<ActivitiesModel>) => {
        return {...data}
      })); 
  }

  postActivities(request: ActivitiesPostModel): Observable<DataEndpoint<any>> {
    const url = this.ACTIVITIES;
    
    return this.http.post<DataEndpoint<any>>(url, request)
      .pipe(map((data: DataEndpoint<any>) => {
        return {...data}
      })); 
  }
  
  getActivityFiles(activityId: string): Observable<DataEndpoint<ActivityFilesModel[]>> {
    const url = `${this.ACTIVITIES}/${activityId}`;

    return this.http.get<DataEndpoint<ActivityFilesModel[]>>(url)
      .pipe(map((data: DataEndpoint<ActivityFilesModel[]>) => {
        return {...data}
      })); 
  }

  postActivityFiles(activityId: string, request: FormData): Observable<DataEndpoint<any>> {
    const url = `${this.ACTIVITIES}/${activityId}`;
    
    return this.http.post<DataEndpoint<any>>(url, request)
      .pipe(map((data: DataEndpoint<any>) => {
        return {...data}
      })); 
  }
}
